import React, {useContext} from 'react';
import PropTypes from "prop-types";
import {joinClassNames} from "@dts-soldel/dts-react-common";
import MobXContext from "../../../app/mobx/MobXContext";
import {observer} from "mobx-react";

const propTypes = {
	// how many "tab stops" to move over the line
	indent: PropTypes.number.isRequired,

	// if the given field matches the one in the ConfiguratorStore then it will be highlighted as changed
	highlightableField: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

	// should this line be highlighted no matter what
	forceHighlighted: PropTypes.bool,

	// the string to show in the line of output
	children: PropTypes.any.isRequired,
};
const defaultProps = {
	children: null,
	forceHighlighted: false,
};

const indentCLOB = i => <span key={i}>&nbsp;&nbsp;&nbsp;&nbsp;</span>;

const OutputLine = ({children, highlightableField, indent, forceHighlighted}) => {
	const {configuratorStore} = useContext(MobXContext);

	const lineIsHighlighted = (forceHighlighted || (configuratorStore.lastChangedField && (configuratorStore.lastChangedField === highlightableField)));

	return (
		children ?
			<div className={joinClassNames(
				"configurator__outputs__line",
				lineIsHighlighted && 'configurator__outputs__line-highlighted'
			)}>
				{Array.from({length: indent}, (_, i) => indentCLOB(i))}
				{children}
			</div>
			: undefined
	);
};

OutputLine.propTypes = propTypes;
OutputLine.defaultProps = defaultProps;

export default observer(OutputLine);
